<script>
import {gmapApi} from 'vue2-google-maps';

export default {
    name: "ApplicationSelectFieldsComponent",

    props: {
        fields:                 Array,
        season:                Number,
        regionData:            Object,
        meteoPoints:           Array,
        selectedMeteoPointId:  {
            type: [Number],
            default: null,
            required: false,
        }
    },

    data: function () {
        return {
            defaultMeteoPointColor:  '#5fa1b6',
            selectedMeteoPointColor: '#ff9301',
            disabledMetePointColor:  '#d9d9d9',
            map:                     null,
            tipObj:                  null,
            offset: {
                x: 10,
                y: 10
            },
            fieldsLocal:              this.fields,
            polygons:                null,
            selectedMetePoint:       null,
            regionCenter:            null,
            isMeteoPointsHidden:     false,
        };
    },

    mounted() {
        Livewire.on('hide-meteo-points', this.hideMeteoPoints);

        Livewire.on('change-field-select-status-on-list-event', this.changeFieldSelectedStatus);

        Livewire.on('update-application-map-data', this.updateMapData);

        Livewire.on('reset-meteo-point', this.resetMeteoPoint);
        Livewire.on('re-init-all-map', this.reInitAllMap);

        this.$refs.mapElCr.$mapPromise.then((map) => {
            this.initMap(map);
        });
    },

    computed: {
        google: gmapApi,

        selectedMeteoPointOption: function() {
            return {strokeColor: this.selectedMeteoPointColor, fillColor: this.selectedMeteoPointColor};
        },

        defaultMeteoPointOption: function () {
            return { strokeColor: this.defaultMeteoPointColor, fillColor: this.defaultMeteoPointColor }
        },

        disabledMeteoPointOption: function () {
            return { strokeColor: this.disabledMetePointColor, fillColor: this.disabledMetePointColor }
        },

        selectedFieldOption: function () {
            return {fillColor: 'rgba(0, 132, 202, 1)', strokeColor: '#0f577a', styleName: 'selected'};
        },

        freeFieldOption: function () {
            return {fillColor: 'rgba(76, 174, 1, 1)', strokeColor: '#000000', styleName: 'free'}
        },

        disabledFieldOption: function () {
            return {fillColor: 'rgba(196, 196, 196, 1)', strokeColor: '#7C7C7C', styleName: 'disabled'}
        },

        meteoPointStep: function () {
            return this.season >= 2019 ? 0.04 : 0.125;
        }
    },

    methods: {
        reInitAllMap() {
            console.log('aaaAA');
        },

        initMap: function (map) {
            this.map = map;

            if(this.meteoPoints) {

                if (this.selectedMeteoPointId) {
                    const meteoPoint = this.meteoPoints.find(x => x.id === this.selectedMeteoPointId)
                    this.drawMeteoPoint(meteoPoint, this.selectedMeteoPointOption, false);
                    this.map.setZoom(11);
                } else {
                    this.drawAllMeteoPoints(this.defaultMeteoPointOption);
                }
            } else {
                this.map.setZoom(11);
            }

            if(this.fields) {
                let bounds = this.drawFields();
                // this.map.fitBounds(bounds);
            }
        },

        drawAllMeteoPoints: function (polygonOptions, zIndex = 0) {
            this.meteoPoints.forEach((meteoPoint) => {
                this.drawMeteoPoint(meteoPoint, polygonOptions, true, zIndex);
            });
        },

        drawMeteoPoint: function (meteoPoint, polygonOptions, selectable, zIndex) {

            if(this.isMeteoPointsHidden) {
                return;
            }

            const { lat, lon } = meteoPoint;
            const square = this.getSector(lat, lon);

            let polygon = new this.google.maps.Polygon({
                paths: square,
                strokeOpacity: 0.9,
                strokeWeight: 1,
                fillOpacity: 0.2,
                point: meteoPoint,
                zIndex: zIndex,
            });

            meteoPoint.polygon = polygon;

            polygon.setOptions(polygonOptions);

            if(selectable) {
                this.google.maps.event.addListener(polygon, 'click', (e) => {
                    this.selectMeteoPoint(polygon.point);
                })
            }

            polygon.setMap(this.map);
        },

        getSector: function(lat, lng) {
            const NW = { lat: lat - this.meteoPointStep, lng: lng - this.meteoPointStep }
            const SW = { lat: lat - this.meteoPointStep, lng: lng + this.meteoPointStep }
            const SE = { lat: lat + this.meteoPointStep, lng: lng + this.meteoPointStep }
            const NE = { lat: lat + this.meteoPointStep, lng: lng - this.meteoPointStep }
            return [NW, SW, SE, NE]
        },

        drawFields: function (zIndex = 10) {

            let latlngbounds = new google.maps.LatLngBounds();
            let hasGeo = false;
            this.fieldsLocal.forEach((field) => {
                let geo = field.geo;

                if(geo === null) {
                    geo = [];
                }
                hasGeo = geo.length > 0;
                let polygonBounds = new google.maps.LatLngBounds();

                geo = geo.map(c => {
                    polygonBounds.extend(new google.maps.LatLng(c.lat, c.lng));
                    return {
                        lng: parseFloat(c.lng), lat: parseFloat(c.lat)
                    };
                });

                if (polygonBounds.getCenter().lat() && polygonBounds.getCenter().lng()) {
                    latlngbounds.extend(new google.maps.LatLng(polygonBounds.getCenter().lat(), polygonBounds.getCenter().lng()));
                }

                let polygon = new this.google.maps.Polygon({
                    paths: geo,
                    strokeWeight: 1,
                    fillOpacity: 1,
                    editable: false,
                    field: field,
                    zIndex: zIndex,
                });

                polygon.setOptions(this.freeFieldOption);

                if(field.selected) {
                    polygon.setOptions(this.selectedFieldOption);
                }

                if(field.disabled) {
                    polygon.setOptions(this.disabledFieldOption);
                }

                polygon.setMap(this.map);

                this.addListenerOnPolygon(polygon, field);

                field.polygon = polygon;
            });

            return hasGeo ? latlngbounds : false;
        },


        addListenerOnPolygon(polygon, field) {
            this.google.maps.event.addListener(polygon, 'mouseover', (e) => {
                this.injectTooltip(e, field.field_id + `, ${parseInt(field.acreage)} га${(field.comment ? ` (${field.comment})` : '')}`);
            });

            this.google.maps.event.addListener(polygon, 'mousemove',  (e) => {
                this.moveTooltip(e);
            });

            this.google.maps.event.addListener(polygon, 'mouseout',  (e) => {
                this.deleteTooltip(e);
            });

            this.google.maps.event.addListener(polygon, 'click', (e) => {
                if(!field.disabled) {
                    if(field.selected) {
                        field.selected = false;
                        polygon.setOptions(this.freeFieldOption);
                    } else {
                        field.selected = true;
                        polygon.setOptions(this.selectedFieldOption);
                    }
                    Livewire.emit('change-field-select-status-on-map-event', field.id, field.selected);
                }
            })
        },

        changeFieldSelectedStatus: function (status, index, fieldId)
        {
            let field = this.fieldsLocal.find(f => f.id === fieldId);
            field.selected = status;

            if(status) {
                field.polygon.setOptions(this.selectedFieldOption);
            } else {
                field.polygon.setOptions(this.freeFieldOption);
            }
        },

        updateMapData: function (meteoPoints, fields, center)
        {
            if(this.meteoPoints !== undefined) {
                this.meteoPoints.forEach((meteoPoint) => {
                    meteoPoint.polygon.setMap(null);
                });
            }

            if(this.fieldsLocal !== undefined) {
                this.fieldsLocal.forEach((field) => {
                    field.polygon.setMap(null);
                });
            }

            this.regionCenter = center;
            this.meteoPoints = meteoPoints;
            this.fieldsLocal = fields;

            if(this.meteoPoints.length) {
                this.drawAllMeteoPoints(this.defaultMeteoPointOption);
            }


            let bounds = this.drawFields(0);
            if (bounds) {
                this.map.fitBounds(bounds);
            } else {
                this.map.setCenter(this.regionCenter);
                this.map.setZoom(8);
            }
        },

        selectMeteoPoint: function (point)
        {
            this.selectedMetePoint = point;
            this.map.setCenter({lat: point.lat, lng: point.lon});
            this.map.setZoom(11);

            this.meteoPoints.forEach((meteoPoint) => {
                meteoPoint.polygon.setMap(null);
            });

            this.drawMeteoPoint(point, this.selectedMeteoPointOption, false);

            this.fieldsLocal.forEach((field) => {
                field.polygon.setMap(null);
            });

            this.drawFields();

            Livewire.emit('select-meteo-point', point.id);
        },

        resetMeteoPoint: function () {
            this.selectedMetePoint.polygon.setMap(null);
            // this.map.setZoom(8);
            // this.map.setCenter(this.regionCenter);

            this.drawAllMeteoPoints(this.defaultMeteoPointOption, 11);
        },

        hideMeteoPoints: function () {
            this.isMeteoPointsHidden = true;
        },

        injectTooltip: function(event,data) {
            if(!this.tipObj && event){
                //create the tooltip object
                this.tipObj = document.createElement("div");
                this.tipObj.style.background = "rgba(0, 0, 0, 0.8)";
                this.tipObj.style.borderRadius = "3px";
                this.tipObj.style.padding = "4px 9px";
                this.tipObj.style.fontFamily = "Arial,Helvetica";
                this.tipObj.style.fontSize = "12px";
                this.tipObj.style.textAlign = "center";
                this.tipObj.style.color = "#fff"
                this.tipObj.style.zIndex = "10"
                this.tipObj.innerHTML = data;

                //fix for the version issue
                let eventPropNames = Object.keys(event);
                if(!this.coordPropName){
                    //discover the name of the prop with MouseEvent
                    for(var i in eventPropNames){
                        var name = eventPropNames[i];
                        if(event[name] instanceof MouseEvent){
                            this.coordPropName = name;
                            break;
                        }
                    }
                }

                if(this.coordPropName){
                    //position it
                    this.tipObj.style.position = "fixed";
                    this.tipObj.style.top = event[this.coordPropName].clientY + this.offset.y + "px";
                    this.tipObj.style.left = event[this.coordPropName].clientX + this.offset.x + "px";

                    //add it to the body
                    document.body.appendChild(this.tipObj);
                }
            }
        },

        moveTooltip: function(event){
            if(this.tipObj && event && this.coordPropName){
                //position it
                // this.tipObj.style.top = event[this.coordPropName].clientY + window.scrollY + this.offset.y + "px";
                this.tipObj.style.top = event[this.coordPropName].clientY + this.offset.y + "px";
                // this.tipObj.style.left = event[this.coordPropName].clientX + window.scrollX + this.offset.x + "px";
                this.tipObj.style.left = event[this.coordPropName].clientX + this.offset.x + "px";
            }
        },

        deleteTooltip: function(event){
            if(this.tipObj){
                //delete the tooltip if it exists in the DOM
                document.body.removeChild(this.tipObj);
                this.tipObj = null;
            }
        },

    }
}
</script>

<style scoped>

</style>
